import format from 'date-fns/format';

export const formatDatetime = (date: string): string => {
  if (!date) {
    return '-';
  }
  return format(new Date(date), 'yyyy.MM.dd HH:mm:ss');
};

export const formatDuration = (duration: number): string => {
  if (!duration) {
    return '-';
  }

  const hours = duration / 60;
  const rHours = Math.floor(hours);
  const minutes = (hours - rHours) * 60;
  const rMinutes = Math.round(minutes);

  return `${rHours.toLocaleString(undefined, { minimumIntegerDigits: 2 })}:${rMinutes.toLocaleString(undefined, {
    minimumIntegerDigits: 2,
  })}`;
};
